export const beaconUtils = () => {
    const getOriginalBeacon = () => {
        // @ts-ignore
        return window.Beacon;
    };

    const init = (...params) => {
        const OriginalBeacon = getOriginalBeacon();

        return OriginalBeacon("init", ...params);
    }

    const open = (...params) => {
        const OriginalBeacon = getOriginalBeacon();

        return OriginalBeacon("open", ...params);
    };

    const close = (...params) => {
        const OriginalBeacon = getOriginalBeacon();
        
        return OriginalBeacon("close", ...params);
    }

    const toggle = (...params) => {
        const OriginalBeacon = getOriginalBeacon();
        
        return OriginalBeacon("toggle", ...params);
    };

    const navigate = (...params) => {
        const OriginalBeacon = getOriginalBeacon();
        
        open();
        return OriginalBeacon("navigate", ...params);
    };

    const identify = (...params) => {
        const OriginalBeacon = getOriginalBeacon();
        
        return OriginalBeacon("identify", ...params);
    }

    const on = (...params) => {
        const OriginalBeacon = getOriginalBeacon();
        
        return OriginalBeacon("on", ...params);
    }

    const info = (...params) => {
        const OriginalBeacon = getOriginalBeacon();
        
        return OriginalBeacon("info", ...params);
    };

    return {
        getOriginalBeacon,
        init,
        open,
        close,
        toggle,
        navigate,
        identify,
        on,
        info,
    };
}
